
import styled from "styled-components"

const Container = styled.button`
    background-color: ${({bgColor})=> bgColor};
    color: ${({color})=> color};
    border-radius: ${({radius})=> radius};
    width: ${({width})=> width};
    padding: ${({padding})=> padding};
    font-size: ${({fontSize})=> fontSize};
    text-align: center;
    height: 40px;
    font-weight: var(--font-weight-md);
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid;
    border-color: ${({borderColor}) => borderColor};
`

const BtnOutline = ({children, width, bgColor="transparent", borderColor="var(--color-main)", height="40px", padding="0", fontSize="14px", radius="10px", handleClick, color }) => {
  return (
    <Container width={width} padding={padding} bgColor={bgColor} borderColor={borderColor} fontSize={fontSize} radius={radius} height={height} onClick={handleClick} color={color}>
        {children}
    </Container>
  )
}

export default BtnOutline